<template>
  <div class="case-container flex-box">
    <div class="case-container-title">{{ title }}</div>
    <div class="case-container-description">{{ description }}</div>
    <div class="carousel-container">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="(item, index) in caseList" class="swiper-slide" :key="index">
            <div class="case-item pointer">
              <div class="case-top-img">
                <el-image
                  class="preview-shot"
                  fit="contain"
                  :src="item.img"
                  :preview-src-list="previewImgs"
                />
              </div>
              <div class="case-bottom-context flex-box">
                <div class="case-item-content">
                  <div class="case-item-label">{{ item.label }}</div>
                  <div class="case-item-describe" v-if="item.describe">{{ item.describe }}</div>
                  <ul class="case-item-advantage" v-if="item.advantage">
                    <li v-for="(advantage, index) in item.advantage" :key="index">{{ advantage }}</li>
                  </ul>
                </div>
                <div class="case-item-btn" @click="toLink(item)">
                  <span class="button-text">了解详情</span>
                  <el-image :src="require('@/assets/images/link-to.png')" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>



export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    caseList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    previewImgs() {
      return this.caseList.map(item => item.img).filter(Boolean)
    }
  },
  mounted() {
  },
  methods: {
    toLink(item) {
      window.open(item.link)
    },
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.swiper-container{
  width: 100%;
  height: 100%;
  .swiper-wrapper {
    display: block;
    text-align: left !important;
  }
  
  .swiper-slide{
    width: 44rem !important;
    margin: 2rem !important;
    display: inline-block;
  }
}

.case-container {
  width: 100%;
  padding: 10rem 0 9.9rem 0;
  background: rgba(203,203,203,0.2);
  flex-direction: column;
  overflow-x: hidden;
  background: #F8F8F8;

  .case-container-title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 1.9rem;
    text-align: center;
  }

  .case-container-description {
    font-size: 1.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 6rem;
    text-align: center;
  }

  .carousel-container {
    width: 100%;
   
    .swiper-wrapper {
      width: calc(192rem - 48rem);
      margin: 0 auto;
      text-align: center;
    }

    .case-item {
      width: 44rem;
      background: #fff;
      border: 0.1rem solid #FFFFFF;
      position: relative;
      box-shadow: 0rem 0.5rem 4rem 0rem rgba(196,211,228,0.6);

      .case-top-img {
        width: 100%;
        height: 34rem;
        background: #f4f6f8;
        overflow: hidden;
        img,
        ::v-deep .preview-shot {
          width: 100%;
          height: 100%;
          display: block;
          cursor: zoom-in;
        }
        ::v-deep .preview-shot .el-image__inner {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
        }
      }

      .case-bottom-context {
        padding: 2rem;
        flex-direction: column;
        align-items: center;

        .case-item-content {
          text-align: left;
          width: 100%;
          font-size: 1.7rem;
          .case-item-describe {
            color: #4a5565;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3; /* 最多显示3行 */
            overflow: hidden;
            text-overflow: ellipsis;
            height: 7rem;
          }
          .case-item-advantage {
            padding: 1rem 0 1rem 2rem;
            margin: 0;
            min-height: 10rem;
            color: #00a63e;
          }
        }

        .case-item-label {
          font-size: 2.2rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 2.4rem;
          margin-bottom: 1rem;
        }

        .case-item-btn {
          background: linear-gradient(140deg, #FF7662 0%, #F34A1F 100%);
          box-shadow: 0 1rem 1.2rem 0 rgba(255,204,196,0.6);
          border-radius: 1.8rem;
          border: 0.1rem solid #FFFFFF;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0.8rem 2.2rem;

          font-size: 1.4rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 2rem;

          &:active {
            box-shadow: 0 1rem 1.2rem 0 rgba(255,204,196,1);
          }
          .el-image {
            width: 2rem;
            height: 2rem;
          }
        }
      }
    }

  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .case-container {
    padding: 4.8rem 0 6.4rem;
    .case-container-title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      padding: 0 1.6rem;
    }
    .case-container-description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      padding: 0 1.6rem;
      margin-bottom: 2.4rem;
    }
    .carousel-container .swiper-wrapper,
    .swiper-wrapper {
      width: 100% !important;
      max-width: 100%;
    }
    .swiper-slide,
    .carousel-container .swiper-slide,
    .case-item {
      width: calc(100% - 3.2rem) !important;
      max-width: calc(100% - 3.2rem);
      margin: 0 1.6rem 1.6rem !important;
    }
    .case-top-img {
      height: auto !important;
      min-height: 0;
      padding-top: 0;
      background: #f4f6f8;
      img,
      ::v-deep .preview-shot {
        width: 100%;
        height: auto;
        object-fit: contain;
      }
      ::v-deep .preview-shot .el-image__inner {
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }
    .case-item-label,
    .case-item-advantage,
    .carousel-container .case-item .case-item-describe,
    .case-item-describe {
      display: block !important;
      width: 100%;
      height: auto !important;
      min-height: 0;
      -webkit-line-clamp: unset !important;
      overflow: visible !important;
      white-space: normal;
      word-break: break-word;
    }
  }
}
</style>
